// extracted by mini-css-extract-plugin
export default {"investorList":"calling-pipeline_investorList__MioIy"};